// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const NewTransferButtonGroup = props =>
    <section className='new-transfer-button-group'>
        <button
            className='secondary'
            onClick={props.onCancelClick}
        >
            <FormattedMessage id='CANCEL'/>
        </button>
        <button
            className='secondary'
            onClick={props.onResetClick}
        >
            <FormattedMessage id='RESET'/>
        </button>
        <button
            className={props.transferClassName}
            disabled={props.disableTransfer}
            onClick={props.onCreateTransferClick}
        >
            <FormattedMessage id='TRANSFER'/>
        </button>
    </section>;

NewTransferButtonGroup.displayName = 'NewTransferButtonGroup';
NewTransferButtonGroup.propTypes = {
    disableTransfer: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onCreateTransferClick: PropTypes.func.isRequired,
    onResetClick: PropTypes.func.isRequired,
    transferClassName: PropTypes.string.isRequired
};

export default NewTransferButtonGroup;




// WEBPACK FOOTER //
// ./src/product/new-transfer/components/new-transfer-button-group.js